<template>
  <div class="visual-schedule-row" :class="{ 'is-remote': !isPrimaryTherapist }">
    <div id="cardContent" class="visual-schedule-col mb-3">
      <div v-if="visualSchedule.staticContent" v-html="visualSchedule.staticContent"></div>
      <component v-else :is="template" id="visualScheduleCards" :previewMode="previewMode"></component>
    </div>
    <div v-if="hasSubtask" class="visual-schedule-col">
      <Subtask :previewMode="previewMode" />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { PlanComplete, FirstThen, CheckOff, TrashCan } from './templates/index';
import { Subtask } from './subtasks/index';
import RevealImageManager from './RevealImageManager.vue';

export default {
  name: 'VisualScheduleViewer',

  components: {
    PlanComplete,
    FirstThen,
    CheckOff,
    TrashCan,
    Subtask,
    RevealImageManager,
  },

  props: {
    previewMode: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState(['visualSchedule', 'templateOptions', 'subtaskCounterOptions']),
    ...mapGetters(['isPrimaryTherapist']),

    scheduleWidth() {
      return `col-md-${this.subtaskId === 1 ? '12' : '6'}`;
    },

    showCounter() {
      return this.visualSchedule.patient_can_see_subtask_count;
    },

    subtaskId() {
      return this.visualSchedule.visual_schedule_subtask_id;
    },

    hasSubtask() {
      const subtask = this.subtaskCounterOptions.find((st) => st.id === this.visualSchedule.visual_schedule_subtask_id);
      if (!subtask) return false;
      return subtask.name !== 'None';
    },

    template() {
      let component;
      const template = this.templateOptions.find((t) => t.id === this.visualSchedule.visual_schedule_template_id);
      if (!template) return null;

      if (template.name.includes('Plan')) {
        component = 'PlanComplete';
      } else if (template.name.includes('First')) {
        component = 'FirstThen';
      } else if (template.name.includes('Check')) {
        component = 'CheckOff';
      } else if (template.name.includes('Trash')) {
        component = 'TrashCan';
      }

      return component;
    },
  },
};
</script>
